export enum ReviewThreadStatus {
  OPEN = "open",
  RESOLVED = "resolved",
}

export enum ReviewSubjectType {
  COURSE_CERTIFICATE = "course_certificate",
  INSURANCE_POLICY = "insurance_policy",
  TEACHING = "teaching",
  REDUCTION = "reduction",
  LEGAL_AID = "legal_aid",
  AUTHORSHIP = "authorship",
  DISPENSATION = "dispensation",
}

export interface ReviewThreadListItemModel {
  id: string;
  documentId: string | null;
  subjectType: string;
  subjectId: string;
  status: ReviewThreadStatus | string;
  assignedAdminUserId: string | null;
  assignedAdminDisplayName: string | null;
  assignedAt: string | null;
  resolvedByAdminUserId: string | null;
  resolvedByAdminDisplayName: string | null;
  resolvedAt: string | null;
  createdAt: string;
  updatedAt: string;
  ownerUserId: string;
  ownerDisplayName: string;
  commentCount: number;
  lastCommentAt: string | null;
}
